import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { JobsService } from '../../shared/services/jobs.service';
import { LanguageService } from '../../shared/services/language.service';
import { UtilsService } from '../../shared/services/utils.service'
import { Title } from '@angular/platform-browser';

declare var $:any; import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.css']
})
export class JobComponent implements OnInit {

  public allJobs:any = []
  public actualJob:any = {}

  public dispoJob = true

  public otherJobs = []

  public formDatas:any = {
      "firstName" : "",
      "lastName" : "",
      "email" : "",
      "description" : "",
      "cv" : null,
      "coverLetter" : null
  }

  public formErrors = [false, false, false, false, false, false]

  public filenames = {
      "cv" : "",
      "coverLetter" : ""
  }

  public modalText = ""

  constructor(
      public jobsService : JobsService,
      public translate : TranslateService,
      public language : LanguageService,
      public activatedRoute: ActivatedRoute,
      public utilsService : UtilsService,
      public title: Title,
  ) { }

  ngOnInit() {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.refreshJobs(params['jobId'].split("-")[0])
      });
  }

  refreshJobs(jobId){
      this.allJobs = []
      this.otherJobs = []
      this.actualJob = {}
      this.jobsService.getJobs()
      .then((res)=>{
          this.allJobs = res
          if(!this.allJobs.filter(job => job.id == jobId).length){
              this.dispoJob = false
          }
          else{
              this.actualJob = this.allJobs.filter(job => job.id == jobId)[0]
          }
          var otherJobsIds = []
          for(var i=0;i<5;i++){
              var jobs = this.allJobs.filter(job => job.id != this.actualJob.id && !otherJobsIds.includes(job.id))
              if(jobs.length){
                  otherJobsIds.push(jobs[Math.floor(Math.random() * jobs.length)].id)
              }
          }
          for(let jobId of otherJobsIds){
              var futureJob = this.allJobs.filter(job => job.id==jobId)[0]
              if(futureJob['name_'+this.translate.store.currentLang] && futureJob['description_'+this.translate.store.currentLang]){
                  this.otherJobs.push(futureJob)
              }

          }
          this.translate.get('Recrutement').subscribe((res1: string) => {
              this.translate.get('Annonce indisponible').subscribe((res2: string) => {
                  if(!this.dispoJob){
                      this.title.setTitle(res1+ ' - '+res2);
                  }
                  else{
                      if(this.actualJob['name_'+this.translate.store.currentLang]){
                          this.title.setTitle(res1+ ' - '+this.actualJob['name_'+this.translate.store.currentLang]);
                      }
                      else{
                          this.title.setTitle(res1);
                      }
                  }
              })
          })
      })
  }

  formateJobLink(id, name){
      var link =  id+"-"+name
      link = link.replace(/[^a-zA-Z0-9-_çïëüâêîôûèàùé ]/g, '')
      link = link.replace(/[\s]{2,}/g," "); // Enlève les espaces doubles, triples, etc.
      link = link.replace(/^[\s]/, ""); // Enlève les espaces au début
      link = link.replace(/[\s]$/,""); // Enlève les espaces à la fin
      link = link.replace(/ /g, '-')

      if(this.language.langs.indexOf(this.translate.store.currentLang)>0){
          link+='-'+this.translate.store.currentLang
      }
      return link
  }


  addPDF(event, pdf){
      this.filenames[pdf] = ""
      this.formDatas[pdf] = null
      var myReader:FileReader = new FileReader();
      let fileList: FileList = event.target.files;
      let file: File = fileList[0];
      if(file.name.toLowerCase().slice(-4) != ".pdf"){
          this.filenames[pdf] = "error"
      }
      else{
          this.filenames[pdf] = file.name
          myReader.onloadend = (event) => {
              this.formDatas[pdf] = myReader.result;
          }
          myReader.readAsDataURL(file);
      }

  }

  modalPostule(){
      if(isBrowser()) $('#sendButton').removeAttr('disabled')
      if(isBrowser()) $('#sendButton').removeClass('disabled')
      this.translate.get('Envoyer').subscribe((res: string) => {
          if(isBrowser()) $('#sendButton').html(res)
      })
      this.formDatas = {
          "firstName" : "",
          "lastName" : "",
          "email" : "",
          "description" : "",
          "cv" : null,
          "coverLetter" : null
      }

      this.formErrors = [false, false, false, false, false, false]

      this.filenames = {
          "cv" : "",
          "coverLetter" : ""
      }
      if(isBrowser()) $('#postuleModal').modal('show')
  }

  postForJob(){
      var formValid = true
      this.formErrors = [false, false, false, false, false, false]

      var conditions = [
          !this.utilsService.isEmpty(this.formDatas.lastName),
          !this.utilsService.isEmpty(this.formDatas.firstName),
          this.utilsService.validMail(this.formDatas.email),
          !this.utilsService.isEmpty(this.formDatas.description),
          this.formDatas.cv,
          this.formDatas.coverLetter
      ]

      for(var i=0;i<conditions.length;i++){
          if(!conditions[i]){
              formValid = false
              this.formErrors[i] = true
          }
      }

      if(formValid){
          if(isBrowser()) $('#sendButton').attr('disabled', 'disabled')
          if(isBrowser()) $('#sendButton').addClass('disabled')
          this.translate.get('Envoi...').subscribe((res: string) => {
              if(isBrowser()) $('#sendButton').html('<i class="material-icons">more_horiz</i> '+res)
          })


          this.jobsService.applyJob(this.actualJob.id, this.formDatas)
          .then((res)=>{
              if(res.status == "success"){
                  this.modalText = this.language.translate.instant('Votre demande a été prise en compte, vous allez être recontacté')
                  if(isBrowser()) $('#postuleModal').modal('hide')
                  if(isBrowser()) $('#postuleModalSuccess').modal('show')
              }
              else{
                  if(res.cause && res.cause == 'noPdf'){
                      this.modalText = this.language.translate.instant('Erreur: Veuillez sélectionner des fichiers pdf corrects')
                      if(isBrowser()) $('#postuleModal').modal('hide')
                      if(isBrowser()) $('#postuleModalSuccess').modal('show')
                  }
                  else{
                      this.modalText = this.language.translate.instant('Une erreur est survenue, veuillez réessayer plus tard')
                      if(isBrowser()) $('#postuleModal').modal('hide')
                      if(isBrowser()) $('#postuleModalSuccess').modal('show')
                  }
              }
          })

      }

  }


}
